import {
  Divider,
  FieldLabel,
  Heading,
  Stack,
  Text,
  Tiles,
} from 'braid-design-system';

import type { FormValues } from '#src/pages/manage/security-breach/SecurityBreach.tsx';

interface ThanksViewProps {
  formValues: FormValues;
  terminateIntegration: boolean;
}

export const ThanksView = ({
  formValues,
  terminateIntegration,
}: ThanksViewProps) => (
  <Stack space="medium">
    <Stack space="medium">
      <Heading level="3">Thank you for submitting a report.</Heading>
      <Text>
        {' '}
        If you need to provide further information, submit another report.
      </Text>
      <Text>You can expect an update from SEEK during ANZ business hours.</Text>
      <Text>
        Here is a copy of your report and actions taken by SEEK. Keep a copy of
        this for your records.
      </Text>
    </Stack>

    <Divider />

    <Stack space="medium">
      <Heading level="4">Report Details</Heading>

      <Tiles space="medium" columns={2}>
        {Object.entries(formValues).map(([label, value]) => (
          <Field key={label} label={label} value={value} />
        ))}
      </Tiles>
      {terminateIntegration && (
        <>
          <Divider />
          <Stack space="small">
            <Heading level="4">Actions Taken by SEEK</Heading>
            <Text>
              Your integration has been put on hold until SEEK can review the
              details of your report.
            </Text>
          </Stack>
        </>
      )}
    </Stack>
  </Stack>
);

const formatLabel = (label: string) =>
  label
    .split(/(?=[A-Z])/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

interface FieldProps {
  label: string;
  value: string;
}

const Field = ({ label, value }: FieldProps) => {
  const id = `field-${label}`;
  const formattedLabel = formatLabel(label);
  return (
    <Stack space="small">
      <FieldLabel htmlFor={id} label={formattedLabel} />
      <Text id={id}>{value}</Text>
    </Stack>
  );
};
